export default __webpack_public_path__ + "static/media/90ea965a08312024e4b960085447e1ba1575638097532.19f8e7bb.webp";